<div class="filters-dropdown" [class.hide]="!visible">
  <div class="filters-header section">
    <h2>Filters</h2>
    <button id="referral-filters-close-btn" class="close" (click)="close()">
      X
    </button>
  </div>
  <div class="filters-body">
    <div class="filter-section-container mb-3">
      <h5 class="mb-2">Urgency</h5>
      <form class="checkboxes" [formGroup]="urgencyForm">
        <div class="row">
          <div class="col-3">
            <mat-checkbox id="filter-urgent" formControlName="Urgent"
              >Urgent</mat-checkbox
            >
          </div>
          <div class="col-3">
            <mat-checkbox id="filter-stroke" formControlName="Stroke"
              >Stroke</mat-checkbox
            >
          </div>
          <div class="col-3">
            <mat-checkbox id="filter-trauma" formControlName="Trauma"
              >Trauma</mat-checkbox
            >
          </div>
        </div>
      </form>
    </div>
    <div class="filter-section-container mb-3">
      <h5 class="mb-2">Modality</h5>
      <form class="checkboxes" [formGroup]="modalityForm">
        <div class="row">
          <div class="col-3">
            <mat-checkbox id="CT" formControlName="CT">CT</mat-checkbox>
          </div>
          <div class="col-3">
            <mat-checkbox id="MR" formControlName="MR">MR</mat-checkbox>
          </div>
          <div class="col-6">
            <mat-checkbox id="PlainFilm" formControlName="PlainFilm"
              >Plain Film</mat-checkbox
            >
          </div>
        </div>
        <div class="row">
          <div class="col-3">
            <mat-checkbox id="US" formControlName="US">US</mat-checkbox>
          </div>
          <div class="col-3">
            <mat-checkbox id="NM" formControlName="NM">NM</mat-checkbox>
          </div>
          <div class="col-3">
            <mat-checkbox id="PT" formControlName="PT">PT</mat-checkbox>
          </div>
          <div class="col-3">
            <mat-checkbox id="Other" formControlName="Other"
              >Other</mat-checkbox
            >
          </div>
        </div>
      </form>
    </div>
    <hr class="mb-2" />
    <div class="filter-section-container mb-3">
      <h5 class="mb-2">Status</h5>
      <form class="checkboxes" [formGroup]="statusForm">
        <div class="row">
          <div class="col-sm">
            <mat-checkbox
              id="filter-awaiting-assignment"
              formControlName="AwaitingAssignment"
              >{{
                statusDisplayMapping.get(referralStatus.AwaitingAssignment)
              }}</mat-checkbox
            >
          </div>
          <div class="col-sm">
            <mat-checkbox
              id="filter-awaiting-decision"
              formControlName="AwaitingDecision"
              >{{
                statusDisplayMapping.get(referralStatus.AwaitingDecision)
              }}</mat-checkbox
            >
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <mat-checkbox
              id="filter-awaiting-acknowledgement"
              formControlName="AwaitingAcknowledgement"
              >{{
                statusDisplayMapping.get(referralStatus.AwaitingAcknowledgement)
              }}</mat-checkbox
            >
          </div>
          <div class="col-sm">
            <mat-checkbox
              id="filter-acknowledged"
              formControlName="Acknowledged"
              >{{
                statusDisplayMapping.get(referralStatus.Acknowledged)
              }}</mat-checkbox
            >
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <mat-checkbox id="filter-on-hold" formControlName="OnHold">{{
              statusDisplayMapping.get(referralStatus.OnHold)
            }}</mat-checkbox>
          </div>
          <div class="col-sm">
            <mat-checkbox
              id="filter-on-clinical-discussion"
              formControlName="ClinicalDiscussionRequired"
              >{{
                statusDisplayMapping.get(
                  referralStatus.ClinicalDiscussionRequired
                )
              }}</mat-checkbox
            >
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <mat-checkbox id="filter-cancelled" formControlName="Cancelled">{{
              statusDisplayMapping.get(referralStatus.Cancelled)
            }}</mat-checkbox>
          </div>
          <div class="col-sm">
            <mat-checkbox id="filter-declined" formControlName="Declined">{{
              statusDisplayMapping.get(referralStatus.Declined)
            }}</mat-checkbox>
          </div>
        </div>
        <div class="row">
          <div class="col-sm">
            <mat-checkbox id="filter-deferred" formControlName="Deferred">{{
              statusDisplayMapping.get(referralStatus.Deferred)
            }}</mat-checkbox>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="filters-footer section">
    <button
      mat-stroked-button
      id="referral-filter-clear-btn"
      class="clear"
      [disabled]="!hasFilters"
      (click)="clearFilters()"
    >
      Clear All Filters
    </button>
    <button
      mat-stroked-button
      id="referral-filter-submit-btn"
      class="submit"
      [disabled]="!this.filtersForm.dirty"
      (click)="submitFilters()"
    >
      Apply Filter
    </button>
  </div>
</div>
